var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"item-text":_vm.itemText,"item-value":_vm.itemValue,"append-icon":"arrow_drop_down","flat":_vm.styleFlat},on:{"change":_vm.valueChanged},model:{value:(_vm.selectedOption),callback:function ($$v) {_vm.selectedOption=$$v},expression:"selectedOption"}},'v-autocomplete',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }